var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMoneyOut40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moneyout40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dollar",
    transform: "translate(15.000000, 12.000000)",
    stroke: "#4F4D4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.8125 L4.66910136,13.8125 M4.08333333,8.5 L2.91666667,8.5 M2.33089864,3.1875 L7,3.1875",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91666667,3.1875 C1.30583615,3.1875 0,4.37674363 0,5.84375 C0,7.31075637 1.30583615,8.5 2.91666667,8.5 L2.91666667,8.5",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8.5 C5.38916948,8.5 4.08333333,9.68924363 4.08333333,11.15625 C4.08333333,12.6232564 5.38916948,13.8125 7,13.8125",
    id: "Curve-bottom",
    transform: "translate(5.541667, 11.156250) scale(-1, 1) translate(-5.541667, -11.156250) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 3.1875,
    x2: 3.5,
    y2: 0,
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 17,
    x2: 3.5,
    y2: 13.8125,
    id: "Stick-bottom"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Swoop",
    transform: "translate(30.300000, 3.920000)",
    fill: "#FFCC00",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "End",
    transform: "translate(3.666667, 2.750000) scale(1, -1) rotate(-270.000000) translate(-3.666667, -2.750000) ",
    points: "6.41666667 2.75 0.916666667 6.41666667 0.916666667 -0.916666667"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,5 C9.93958638,5 3,11.9395864 3,20.5 C3,29.0604136 9.93958638,36 18.5,36 C26.8646707,36 33.6817906,29.3741472 33.9891784,21.0846228 C33.9963716,20.8906384 34,9.93167629 34,9.73593337",
    id: "Path",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMoneyOut40);
export default __webpack_public_path__ + "static/media/pictogramMoneyOut40.d2edd41a29657912e04607113b951910.svg";
export { ForwardRef as ReactComponent };